import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createPack } from '../actions';
import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import { red500 } from 'material-ui/styles/colors';

const buttonCreateStyle = {
    marginLeft: 10
};

class CreateDialog extends Component {
    state = {
        name: '',
        desc: '',
        required: false
    };

    handleCreate = () => {
        const { name, desc } = this.state;

        if (!name.length) {
            this.setState({
                required: true
            });
        } else {
            this.props.createPack({
                name: name,
                description: desc
            });

            this.props.toggleCreateDialog();

            this.setState({
                name: '',
                desc: ''
            });
        }
    };

    render() {
        const { required } = this.state;
        const { isOpen, toggleCreateDialog } = this.props;

        const actions = [
            <FlatButton key="Cancel" label="Cancel" primary onClick={toggleCreateDialog} />,
            <RaisedButton key="Create" label="Create" secondary onClick={this.handleCreate} style={buttonCreateStyle} />
        ];

        return (
            <div>
                <Dialog
                    title="Create new pack"
                    actions={actions}
                    modal={false}
                    open={isOpen}
                    onRequestClose={toggleCreateDialog}
                >
                    <span>Specify name and description for new pack.</span>
                    <TextField
                        fullWidth
                        hintText="Must be unique"
                        floatingLabelText="Pack name*"
                        errorText={required && 'Required'}
                        errorStyle={{ red500 }}
                        onChange={(e, value) => {
                            if (value.length) {
                                this.setState({ name: value, required: false });
                            } else {
                                this.setState({ name: value });
                            }
                        }}
                    />
                    <TextField
                        fullWidth
                        floatingLabelText="Pack description"
                        onChange={(e, value) => this.setState({ desc: value })}
                    />
                </Dialog>
            </div>
        );
    }
}

CreateDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggleCreateDialog: PropTypes.func.isRequired,
    // From connect
    createPack: PropTypes.func.isRequired
};

export default connect(
    null,
    { createPack }
)(CreateDialog);



/** WEBPACK FOOTER **
 ** ../src/dash/front/packs/components/CreateDialog.js
 **/